import React from "react";

const ProductVariationChooser = ({
    variation,
    selectedProductColor,
    setSelectedProductColor,
    selectedProductSize,
    setSelectedProductSize,
    setProductStock,
    setQuantityCount,
}) => {
    if (!variation || !variation["@nodes"] || variation["@nodes"].length === 0) return;

    return (
        <div className="pro-details-size-color">
            <div className="pro-details-color-wrap">
                <span>Color</span>
                <div className="pro-details-color-content">
                    {variation["@nodes"].map((single, key) => {
                        const currentVariation = variation[single];
                        const color = currentVariation.color;
                        const size = currentVariation.size["@nodes"][0];

                        return (
                            <label className={`pro-details-color-content--single ${color}`} key={key}>
                                <input
                                    type="radio"
                                    value={color}
                                    name="product-color"
                                    checked={color === selectedProductColor ? "checked" : ""}
                                    onChange={() => {
                                        setSelectedProductColor(color);
                                        setSelectedProductSize(size.name);
                                        setProductStock(size.stock);
                                        setQuantityCount(1);
                                    }}
                                />
                                <span className="checkmark"></span>
                            </label>
                        );
                    })}
                </div>
            </div>
            <div className="pro-details-size">
                <span>Size</span>
                <div className="pro-details-size-content">
                    {variation["@nodes"].map((single) => {
                        const currentVariation = variation[single];
                        const color = currentVariation.color;

                        return color === selectedProductColor
                            ? currentVariation.size["@nodes"].map((singleSize, key) => {
                                  const size = currentVariation.size[singleSize];

                                  return (
                                      <label className={`pro-details-size-content--single`} key={key}>
                                          <input
                                              type="radio"
                                              value={size.name}
                                              checked={size.name === selectedProductSize ? "checked" : ""}
                                              onChange={() => {
                                                  setSelectedProductSize(size.name);
                                                  setProductStock(size.stock);
                                                  setQuantityCount(1);
                                              }}
                                          />
                                          <span className="size-name">{size.name}</span>
                                      </label>
                                  );
                              })
                            : "";
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProductVariationChooser;
